import { render, staticRenderFns } from "./RunningTasksTable.vue?vue&type=template&id=4cc48ff2&"
import script from "./RunningTasksTable.vue?vue&type=script&lang=js&"
export * from "./RunningTasksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports